import Section from "../Section"
import styles from "./IconGrid.module.scss"
import Image from "../Image"
import Link from "../Link"
import { useEffect, useState } from "react"
import cx from "classnames"

const IconGrid = ({ data }) => {
  const [colCount, setColCount] = useState(null)
  const {
    section_teaser,
    section_headline,
    section_subline,
    section_text,
    section_links,
    icons,
    with_background: withBackground,
  } = data

  useEffect(() => {
    if (icons?.length > 0) {
      const itemCount = icons.length
      if (itemCount === 4) {
        setColCount("grid-cols-1 sm:grid-cols-2 lg:grid-cols-4")
      } else if (itemCount === 3) {
        setColCount("grid-cols-1 lg:grid-cols-3")
      } else if (itemCount === 2) {
        setColCount("grid-cols-1 sm:grid-cols-2")
      } else if (itemCount === 1) {
        setColCount("grid-cols-1")
      }
    }
  }, [icons])

  return (
    <Section
      teaser={section_teaser}
      headline={section_headline}
      subline={section_subline}
      text={section_text}
      links={section_links}
    >
      <div className={cx(styles.iconGrid, colCount)}>
        {icons?.length > 0 &&
          icons.map((icon, i) => (
            <div
              key={i}
              className={cx(styles.item, "@container", {
                [styles.bg]: withBackground === true,
              })}
            >
              <div className="flex items-start gap-4 lg:flex-col">
                {icon.icon && (
                  <div className={styles.iconWrapper}>
                    <Image alt={icon.icon.alt} src={icon.icon.permalink} fill />
                  </div>
                )}
                <div>
                  {icon.headline && (
                    <h5 className={styles.headline}>{icon.headline}</h5>
                  )}
                  {icon.text && (
                    <div
                      className={styles.text}
                      dangerouslySetInnerHTML={{ __html: icon.text }}
                    />
                  )}
                  {icon.links?.length > 0 && (
                    <div className={styles.links}>
                      {icon.links.map((link, i) => (
                        <Link key={i} link={link} className="!px-0" />
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
      </div>
    </Section>
  )
}

export default IconGrid
